import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { 
  getSofiaPackages,
  getSofiaBalance,
  getPaymentStatus,
  getListListingSofia,
  getSofiaListingImages,
  getDetailListingSofia,
  getListMarketingSofia,
  getCreditHistory
} from "./api"

// Get list of Sofia credit packages
export const useGetSofiaPackages = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ['get-sofia-packages'],
    queryFn: () => getSofiaPackages(),
    enabled: enabled
  })
}

// Get Sofia credit balance
export const useGetSofiaBalance = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ['get-sofia-balance'],
    queryFn: () => getSofiaBalance(),
    enabled: enabled
  })
}

// Get payment status
export const useGetPaymentStatus = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ['get-payment-status'],
    queryFn: () => getPaymentStatus(),
    enabled: enabled
  })
}

// Get list listing sofia
export const useGetListListingSofia = ({ params = {}, enabled = true } = {}) => {
  return useQuery({
    queryKey: ['get-list-listing-sofia', params],
    queryFn: () => getListListingSofia(params),
    enabled: enabled
  })
}

// Get list listing sofia with infinite scroll
export const useGetListListingSofiaInfinite = ({ params = {}, enabled = true } = {}) => {
  return useInfiniteQuery({
    queryKey: ['get-list-listing-sofia-infinite', params],
    queryFn: ({ pageParam = 1 }) => getListListingSofia({ ...params, page: pageParam }),
    enabled: enabled,
    getNextPageParam: (lastPage) => {
      const currentPage = lastPage.headers["x-page"] ? +lastPage.headers["x-page"] + 1 : lastPage?.config?.params?.page + 1;
      return !!lastPage?.data?.data?.length ? currentPage : undefined
    },
  })
}

// Get detail listing sofia
export const useGetDetailListingSofia = ({ slug, enabled = true } = {}) => {
  return useQuery({
    queryKey: ['get-detail-listing-sofia', slug],
    queryFn: () => getDetailListingSofia(slug),
    enabled: enabled
  })
}

// Get sofia listing images
export const useGetSofiaListingImages = ({ slug, enabled = true } = {}) => {
  return useQuery({
    queryKey: ['get-sofia-listing-images', slug],
    queryFn: () => getSofiaListingImages(slug),
    enabled: enabled
  })
}

// Get marketing sofia
export const useGetMarketingSofia = ({ params = {}, enabled = true } = {}) => {
  return useQuery({
    queryKey: ['get-marketing-sofia', params],
    queryFn: () => getListMarketingSofia(params),
    enabled: enabled
  })
}

// Get marketing sofia with infinite scroll
export const useGetMarketingSofiaInfinite = ({ params = {}, enabled = true } = {}) => {
  return useInfiniteQuery({
    queryKey: ['get-marketing-sofia-infinite', params],
    queryFn: ({ pageParam = 1 }) => getListMarketingSofia({ ...params, page: pageParam }),
    enabled: enabled,
    getNextPageParam: (lastPage) => {
      const currentPage = lastPage.headers["x-page"] ? +lastPage.headers["x-page"] + 1 : lastPage?.config?.params?.page + 1;
      return !!lastPage?.data?.data?.length ? currentPage : undefined
    },
  })
}

// Get credit history
export const useGetCreditHistory = ({ params = {}, enabled = true } = {}) => {
  return useQuery({
    queryKey: ['get-credit-history', params],
    queryFn: () => getCreditHistory(params),
    enabled: enabled
  })
}
